<template>
    <div class="hero">
        <div class="container">
            <div class="trener">
                <img class="img-left" :src="imgBranislav" alt="">
                <p class="ime">Branislav Cvenić</p>
                <p class="biografija"> Studirao sam Fakultet organizacionih nauka u Beogradu, a tokom studija bio sam član nekoliko studentskih organizacija u kojima sam prošao kroz mnogo projekata i funkcija. Prve profesionalne korake napravio sam u kompaniji TerraCore Technologies, gde sam proveo dve i po godine radeći na svim marketing aktivnostima – od dizajna i video montaže, do employer brandinga. Pokrenuo sam i sopstveni E-commerce projekat Sportski zid, namenjen prodaji sportskih slika, a u okviru njega osmislio i vodio talk show Sportski Fid. Trenutno radim kao marketing menadžer u Infostudu, sa fokusom na kreiranje sadržaja i društvene mreže za sve Infostud brendove, a najviše Startuj Infostud. </p>
            </div>


            <div class="trener">
                <img class="img-right" :src="imgSara" alt="">
                <p class="ime">Sara Gojković</p>
                <p class="biografija">Moje ime je Sara i studiram energetiku na Elektrotehničkom fakultetu u Beogradu. Akademiju mekih veština sam organizovala dve godine zaredom, a prošlog leta sam i sama postala trener. Smatram da su meke veštine neizostavan deo kako profesionalnog, tako i ličnog razvoja. To me je podstaklo da ih dublje istražujem, radim na sebi i svoje znanje prenosim drugima. Radujem se da vidim Akademiju i iz ovog ugla!</p>
            </div>


            <div class="trener">
                <img class="img-left" :src="imgAndjela" alt="">
                <p class="ime">Anđela Gazdić</p>
                <p class="biografija">Master sam student na Elektrotehničkom fakultetu u Beogradu i zaposlena u IT firmi. Soft Skill trener sam tri godine, a članstvo u Isteku odveć pet godina. Veliki sam ljubitelj mekih veština bila od ranije, ali sam kroz svoj rad u Isteku ozbiljnije shvatila njihov značaj, te sam želela da dodatno radim na sebi i da sa drugima podelim svoja znanja i iskustvo kroz držanje sesija mekih veština. Sada, u korporativnom svetu, dodatno bivaju od značaja stvari koje sam naučila i primenjujem ih svakodnevno.  
<br><br>
Nadam se lepom i uspešnom druženju na Akademiji mekih veština, kao i na mogobrojnim do sada!</p>
            </div>


            <div class="trener">
                <img class="img-right" :src="imgAntonija" alt="">
                <p class="ime">Antonija Monar</p>
                <p class="biografija">Antonija je sertifikovani soft skills trener koji teži tome da kod ljudi probudi unutrašnju radoznalost i želju za ličnim rastom, jer iz toga kreće svaka veća promena. Strastvena je u tome da inspiriše druge da ostvare svoj puni potencijal, vodeći ih ka iskustvima koja počinju tamo gde prestaje zona komfora. Antonija uživa u šetnjama prirodom, putovanjima i razmenama ideja koje podstiču lični rast.</p>
            </div>

            <div class="trener">
                <img class="img-left" :src="imgSonja" alt="">
                <p class="ime">Sonja Vojnović</p>
                <p class="biografija">Uživam u držanju treninga mekih veština i prenošenju znanja drugima. Kao student Elektrotehničkog fakulteta u Beogradu, rad na mekim veštinama je ono što nisam mogla da istražujem kroz studije, ali sam pronašla kao trener mekih vešina, i upravo to mi je omogućilo da deljenje svog znanja proširim na ljude širom Evrope. Volim da istražujem nove oblasti, a trenutno je moj fokus na emocionalnoj inteligenciji, koja je ključna za lični razvoj i međuljudske odnose.</p>
            </div>


            <div class="trener">
                <img class="img-right" :src="imgAndriana" alt="">
                <p class="ime">Andriana Takić</p>
                <p class="biografija">Andriana Takić je internacionalni EESTEC trener od 2018. godine i nekadašnja vrlo aktivna članica EESTEC beogradskog lokalnog komiteta, kao i internacionalnih timova. Diplomirala je na Elektrotehničkom fakultetu u Beogradu, a potom završila master studije na univerzitetu u Milanu, gde i danas pretežno živi i radi. 
<br><br>
Od malena gaji veliku ljubav prema muzici i pevanju, te i danas aktivno nastupa i učestvuje u muzičkim radionicama širom sveta, sa fokusom na razmenu muzičkih tradicija kroz peer-to-peer učenje. Pored muzike, poslednjih godina je zanimaju prakse koje istražuju telesni pokret, prisutnost, improvizaciju i izražavanje.
<br><br>
Kao trener i edukator, voli da spaja različite oblasti i kreira prostore za iskustveno učenje u kojem učesnici mogu da istraže sebe kroz refleksiju, igru, dijalog i druge forme neformalnog obrazovanja. U njenom radu se prirodno prepliću umetnost, obrazovanje i lični razvoj, a posebno su joj bliske teme kao što su kreativnost, komunikacija, emocionalna inteligencija i upravljanje stresom.</p>
            </div>

            <div class="trener">
                <img class="img-left" :src="imgDarija" alt="">
                <p class="ime">Darija Knežević</p>
                <p class="biografija">Hej hej, moje ime je Darija i trenutno sam master student softverskog inženjerstva na ETF-u. Tokom studiranja i kroz svoj angažman u EESTEC-u, shvatila sam koliko prostora ima za lični rast kada izađeš iz svoje zone komfora. Imala sam priliku da vodim timove, organizujem projekte i događaje, i to ne samo u Beogradu, već i internacionalno, gde sam otkrila koliko volim da podržavam druge u njihovom razvoju.
<br><br>
Posebno me inspirišu treninzi koji nisu samo „još jedna radionica“, već prilika da se ljudi povežu, razmene perspektive i odu sa osećajem da su napravili pomak – makar i mali. Verujem da svaki korak ka boljoj verziji sebe zaslužuje prostor i podršku, i trudim se da to pružim kao trener.
<br><br>
Ko zna, možda baš ova Soft Skills Akademija bude tvoja odskočna daska, da otkriješ nešto novo o sebi i napraviš sledeći korak. Vidimo se uskoro!</p>
            </div>

            <div class="trener">
                <img class="img-right" :src="imgErmin" alt="">
                <p class="ime">Ermin Mujanović</p>
                <p class="biografija">Moje ime je Ermin, dolazim iz Tuzle kao alumni član lokalnog komiteta EESTEC-a u Tuzli, a po struci sam Certified Learning and Development Professional (CLDP).
<br><br>
Moja priča u aktivizmu započela je jednim soft skills treningom – tada sam shvatio da želim biti s one druge strane, kao neko ko podučava i inspiriše druge. Kroz godine angažmana u EESTEC-u prošao sam razne uloge: bio sam kontakt osoba u Tuzli, koordinator lokalnih timova, organizator projekata i, na kraju, predsednik ogranka u Tuzli. No, tu nije bio kraj – svoju strast prema učenju i razvoju prenjeo sam i na internacionalni nivo, gde sam preuzeo odgovornost kao koordinator OVL tima i Lider Trening Tima.
<br><br>
Oba tima su bila usmjerena na razvoj mekih veština, organizaciju treninga i globalne edukativne sesije, što je dodatno učvrstilo moju ljubav prema učenju i podučavanju što je i prouzrokovalo da postanem i CLDP. Upravo zato smatram da je jedan od najboljih načina za usavršavanje i buđenje potencijala jedna akademija mekih vještina.
<br><br>
Ko zna, možda se i tvoje putovanje uskoro promeni – prvo kao učesnik, a onda i kao neko ko pomaže drugima da rastu. Vidimo se na drugoj strani!</p>
            </div>

            <div class="trener">
                <img class="img-left" :src="imgLea" alt="">
                <p class="ime">Lea Popović</p>
                <p class="biografija">Zdravo! Ja sam Lea Popović, apsolventkinja Biotehničkog fakulteta u Ljubljani. 
                    <br><br>
Moja ljubav prema mekim veštinama se rodila pre nešto više od godinu dana, tokom četvorodnevne EESTEC radionice u Ankari posvećene nenasilnoj komunikaciji. Ubrzo nakon toga završila sam međunarodni kurs "Training for Trainers" i postala trener mekih veština. Treninge sam držala širom Balkana i napokon je došlo vreme da održim jedan i kod kuće. Kao apsolventkinja sam se susrela s viškom slobodnog vremena, što me je motivisalo da se dublje posvetim temi produktivnosti i organizacije vremena.</p>
            </div>

        </div>

    </div>

</template>

<script>
export default{

    data(){
        return{
            imgBranislav: require("../assets/treneri/BranislavCvenić.jpg"),
            imgSara: require("../assets/treneri/SaraGojković.jpg"),
            imgAndjela: require("../assets/treneri/AnđelaGazdić.jpg"),
            imgAntonija: require("../assets/treneri/AntonijaMonar.jpg"),
            imgSonja: require("../assets/treneri/SonjaVojnović.jpg"),
            imgAndriana: require("../assets/treneri/AndrianaTakić.jpg"),
            imgDarija: require("../assets/treneri/DarijaKnežević.jpg"),
            imgErmin: require("../assets/treneri/ErminMujanović.png"),
            imgLea: require("../assets/treneri/LeaPopović.jpg")
        }
    }
}

</script>

<style scoped>
    .container{
        display: flex;
        justify-content: space-around;
        flex-wrap: wrap;
    }
    .hero{
        background-image: url("../assets/home_hero_bg.png");
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center center;
        background-attachment: fixed;
        height: 100%;
        left: 0;
        right: 0;
        font-size: 17px;        
        padding-top: 10%;
        padding-bottom: 10%;
    }
    .trener{
        border: 5px solid #11998E;
        height: 100%;
        width: 45%;
        background-color: #38EF7D;
        margin-bottom: 20px;
        border-radius: 20px;
        overflow: hidden;
    }
    .img-left
    {
        border-bottom-right-radius: 20px;
        border-right: 5px solid #11998E;
        border-bottom: 5px solid #11998E;
    }
    .img-right
    {
        border-bottom-left-radius: 20px;
        border-left: 5px solid #11998E;
        border-bottom: 5px solid #11998E;
    }
    @media(max-width: 768px){
        .hero{
            background: #11998e;
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center center;
            background-attachment: fixed;
            height: 100%;
            left: 0;
            right: 0;
            font-size: 17px;        
            padding-top: 10%;
            padding-bottom: 10%;
        }
        .trener{
            border: 5px solid white;
            height: 100%;
            width: 45%;
            background-color: #38EF7D;
            margin-bottom: 20px;
            border-radius: 20px;
            overflow: hidden;
        }
        .img-left 
        {
            border-bottom-right-radius: 20px;
            border-right: 5px solid white;
            border-bottom: 5px solid white;
        }
        .img-right
        {
            border-bottom-left-radius: 20px;
            border-left: 5px solid white;
            border-bottom: 5px solid white;
        }
    }

    .trener{
        margin-top: 15px;
    }

    .trener .img-left{
        float: left;        
        margin-right: 20px;
        margin-bottom: 5px;
    }
    .trener .img-right{
        float: right;
        margin-left: 20px;
        margin-bottom: 5px;
    }
    .ime{
        font-size: 20px;
        font-weight: 700;
    }
    
    .biografija{
        text-align: justify;
        margin: 15px;
    }

@media (max-width: 991px) {
    .container{
        justify-content: center;
    }
    .trener{
        width: 80%;
        margin-top: 40px;
    }
}

@media (max-width: 768px) {
    .trener{
        margin-top: 0px;
        margin-bottom: 20px;
    }
}

@media (max-width: 479px) {

    .trener{
        width: min-content;
    }

    .trener .img-left{
        float: none;
        border: 5px solid white;
    }
    .trener .img-right{
        float: none;
        border: 5px solid white;
    }

    .trener img{
        margin: 10px;
        border-radius: 20px 20px 0px 0px;
    }

    .ime{
        margin: 0px;
        font-size: 15px;
    }

    .biografija{
        font-size: 12px;
    }
}
</style>